import { twMerge } from "tailwind-merge";
import { PlatformHeaderContainer } from "../PlatformHeader/PlatformHeaderContainer";

export type Props = {
  children?: React.ReactNode;
};

export function PlatformSidebar({ children }: Props) {
  return (
    <>
      <PlatformHeaderContainer>{children}</PlatformHeaderContainer>
      <aside
        className={twMerge(
          "hidden md:bg-brand-50 md:block md:fixed md:left-0 md:top-0 md:translate-x-0 md:border-r md:w-64 md:h-full md:shadow-xl md:z-10"
        )}
      >
        <div className="flex flex-col h-full overflow-y-auto p-4 justify-between">
          {children}
        </div>
      </aside>
    </>
  );
}

export default PlatformSidebar;

